import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import DriverDrawer from "components/drawer/DriverDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import DriverServices from "services/DriverServices";
import ViewModal from "components/modal/ViewDriverModal";
import DriverAproveReject from "components/modal/DriverAproveRejectModel";
import EditDeleteButton from "components/table/EditDeleteButton";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import { notifyError, notifySuccess } from "utils/toast";
import React, { useState, useContext } from "react";
import Tooltip from "components/tooltip/Tooltip";
import { MdClose } from "react-icons/md";
import useToggleDrawer from "hooks/useToggleDrawer";
import { SidebarContext } from "context/SidebarContext";
import ShowHideButtonBlock from "components/table/ShowHideButtonBlock";
import RemarkModal from "components/modal/RemarkModal";
import { FiEye } from "react-icons/fi";

const DriverTable = ({
  driver,
  perpage,
  currentPage,
  tab,
  hideDelete,
  hideEdit,
}) => {
  const {
    title,
    serviceBlock,
    serviceId,
    handleModalOpen,
    handleView,
    handleUpdate,
    handleBlock,
  } = useToggleDrawer();
  //console.log("driver data in table", driver);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [isRemarkModalOpen, setIsRemarkModalOpen] = useState(false);
  const { setIsUpdate } = useContext(SidebarContext);
  const [open, setOpen] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState("");
  const handleOpen = (remark) => {
    setSelectedRemark(remark);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const [changesOpen, setChangesOpen] = useState(false);
  const [changesArrayData, setChangesArrayData] = useState("");
  const handleChangesClose = () => setChangesOpen(false);

  const handleChangesOpen = (data) => {
    const before = data?.changes?.before || {};
    const after = data?.changes?.after || {};

    const fieldLabels = {
      driver_name: "Driver Name",
      driver_img: "Driver Image",
      driving_license: "Driving License",
      license_img: "License Image",
      driver_contact_no: "Driver Contact No",
      language_known: "Language Known",
      aadhaar_no: "Aadhaar No",
    };

    const changedFields = Object.keys(after)
      .filter((key) => {
        const beforeValue = Array.isArray(before[key])
          ? before[key].join(", ")
          : before[key];

        const afterValue = Array.isArray(after[key])
          ? after[key].join(", ")
          : after[key];

        return beforeValue !== afterValue;
      })
      .map((key) => ({
        field: fieldLabels[key] || key,
        oldValue: Array.isArray(before[key])
          ? before[key].join(", ")
          : before[key] || "-",
        newValue: Array.isArray(after[key])
          ? after[key].join(", ")
          : after[key] || "-",
      }));

    setChangesArrayData(changedFields);
    setChangesOpen(true);
  };

  // const statusOptions = [
  // 	{ value: 0, label: 'Created' },
  // 	{ value: 1, label: 'Deleted' },
  // 	{ value: 2, label: 'Waiting for Delete' },
  // 	{ value: 3, label: 'Waiting for Approval' },
  // 	{ value: 4, label: 'Waiting for Update' },
  // 	{ value: 5, label: 'Updation Rejected' },
  // 	{ value: 6, label: 'Add Driver Rejected' },
  // 	{ value: 7, label: 'Delete Driver Rejected' },
  // ];

  const statusOptions = [
    { value: 0, label: "Created" },
    { value: 1, label: "Deleted" },

    { value: 2, label: "Waiting for Delete" },
    { value: 10, label: "Waiting for Delete" },

    { value: 3, label: "Waiting for Approval" },
    { value: 8, label: "Waiting for Approval" },

    { value: 4, label: "Waiting for Update" },
    { value: 9, label: "Waiting for Update" },

    { value: 5, label: "Updation Rejected" },
    { value: 6, label: "Add Driver Rejected" },
    { value: 7, label: "Delete Driver Rejected" },
  ];

  // const handleStatusChange = (driverId, newStatus) => {
  // 	let setstatus = 0;

  // 	if (newStatus === 3) {
  // 		setstatus = 6;
  // 	} else if (newStatus === 4) {
  // 		setstatus = 5;
  // 	} else if (newStatus === 2) {
  // 		setstatus = 7;
  // 	}

  // 	if ([6, 5, 7].includes(setstatus)) {
  // 		setSelectedDriver({ id: driverId, newStatus: setstatus });
  // 		setIsRemarkModalOpen(true);
  // 	} else if (setstatus === 3) {
  // 		setSelectedDriver({ id: driverId, newStatus: setstatus });
  // 		setIsRemarkModalOpen(true);
  // 	}
  // };

  const handleStatusChange = (driverId) => {
    setSelectedDriver({ id: driverId });
    setIsRemarkModalOpen(true);
  };

  const handleModalAction = async (action, remark) => {
    try {
      var payload = {};

      // if (action === 'approve') {
      // 	if (selectedDriver.newStatus === 7) {
      // 		payload.status = 1;
      // 	} else {
      // 		payload.status = 0;
      // 	}
      // } else if (action === 'reject') {
      // 	payload = { status: selectedDriver.newStatus };

      // 	if (selectedDriver.newStatus === 5) {
      // 		payload.cancel_update_remarks = remark;
      // 	} else if (selectedDriver.newStatus === 6) {
      // 		payload.cancel_add_remarks = remark;
      // 	} else if (selectedDriver.newStatus === 7) {
      // 		payload.cancel_delete_remarks = remark;
      // 	}
      // }

      if (action === "approve") {
        payload.remarks = "";
      } else if (action === "reject") {
        payload.remarks = remark;
      }

      const response = await DriverServices.updateStatus(
        selectedDriver.id,
        payload,
      );

      if (response.status) {
        setIsUpdate(true);
        return notifySuccess(response.message);
      } else {
        return notifyError(response.message);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      return notifyError("Error updating status.");
    } finally {
      setIsRemarkModalOpen(false);
      setSelectedDriver(null);
    }
  };

  const driverHistory =
    selectedDriver &&
    driver?.find((d) => d.id === selectedDriver.id)?.driverHistory;

  return (
    <>
      <RemarkModal
        id_data={serviceId}
        block_data={serviceBlock}
        title_data={title}
      ></RemarkModal>
      <DeleteModal id={serviceId} title={title} />
      <ViewModal id={serviceId} title={title} data={driver} />

      <MainDrawer>
        <DriverDrawer id={serviceId} />
      </MainDrawer>

      {isRemarkModalOpen && (
        <DriverAproveReject
          isOpen={isRemarkModalOpen}
          onClose={() => setIsRemarkModalOpen(false)}
          title="Approve or Reject"
          driverHistory={driverHistory}
          newStatus={selectedDriver.newStatus}
          onYesClick={() => handleModalAction("approve", "Approved")}
          onRejectClick={(remark) => {
            handleModalAction("reject", remark);
          }}
        />
      )}

      <TableBody>
        {driver?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.client_id}>
            <TableCell className="text-sm text-center">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>

            <TableCell className="text-sm text-center">
              {data.vendor_name}
            </TableCell>

            <TableCell className="text-sm text-center">
              <span className="text-sm">{data.driver_name}</span>
            </TableCell>

            <TableCell className="text-sm text-center">
              {data.driver_contact_no}
            </TableCell>

            {tab !== 0 && tab !== 3 && (
              <TableCell className="text-sm text-center">
                {hideEdit && (
                  <>
                    <div
                      className={
                        data.is_blocked === 1
                          ? "text-red-600 text-sm font-medium"
                          : "text-green-600 text-sm font-medium"
                      }
                    >
                      {data.is_blocked === 1 ? "Blocked" : "Active"}
                    </div>
                    <ShowHideButtonBlock
                      id={data.id}
                      block={data.is_blocked}
                      title_block={"Driver"}
                      handleBlock={handleBlock}
                    />
                  </>
                )}
              </TableCell>
            )}
            {tab !== 1 && tab !== 2 && (
              <TableCell className="text-center">
                {/* //	{console.log(data)} */}
                {hideEdit && (
                  <>
                    {[2, 3, 4, 8, 9, 10].includes(data.status) ? (
                      <>
                        <div className="block">
                          {
                            statusOptions.find(
                              (option) => option.value === data.status,
                            )?.label
                          }
                        </div>
                        <span
                          className="mt-1 inline-block text-sm text-blue-600 cursor-pointer hover:text-blue-800"
                          onClick={() =>
                            handleStatusChange(data.id, parseInt(data.status))
                          }
                        >
                          Action
                        </span>
                      </>
                    ) : (
                      (() => {
                        const label =
                          statusOptions.find(
                            (option) => option.value === data.status,
                          )?.label || "";
                        const labelColorMap = {
                          "Add Driver Rejected": "text-red-500",
                          "Updation Rejected": "text-yellow-500",
                          "Delete Driver Rejected": "text-blue-500",
                        };
                        const textColor = labelColorMap[label] || "";
                        return (
                          <span className={`text-sm font-medium ${textColor}`}>
                            {label}
                          </span>
                        );
                      })()
                    )}
                  </>
                )}
              </TableCell>
            )}

            {/* {tab !== 1 && tab !== 2 && tab !== 3 && (
							<TableCell className="text-sm" style={{ textAlign: "center" }}>
								<span
									className="text-md center"

								>
									{data?.request_type
										? data.request_type.charAt(0).toUpperCase() + data.request_type.slice(1)
										: ""}
								</span>
							</TableCell>
						)}
						{tab !== 1 && tab !== 2 && tab !== 3 && (
							data?.request_type == 'update' ? (<TableCell className="text-sm" style={{ textAlign: "center" }}>
								<span
									className="text-sm text-blue-500 cursor-pointer text-center"
									onClick={() => handleChangesOpen(data)}
								>
									View
								</span>
							</TableCell>) : (<TableCell className="text-sm" style={{ textAlign: "center" }}>
								<span
									className="text-sm center"
								>
									-
								</span>
							</TableCell>
							)
						)} */}

            {tab !== 1 && tab !== 2 && tab !== 3 && (
              <TableCell className="text-sm" style={{ textAlign: "center" }}>
                {/* <span
                                    className="text-md center block"
 
                                >
                                    {data?.request_type == 'add' ? 'New' :
                                        data.request_type.charAt(0).toUpperCase() + data.request_type.slice(1)}
                                </span> */}
                <span
                  className={`text-md center block font-semibold ${
                    data?.request_type === "add"
                      ? "text-green-700"
                      : data?.request_type === "update"
                        ? "text-yellow-500"
                        : "text-gray-800"
                  }`}
                >
                  {data?.request_type === "add"
                    ? "New"
                    : data?.request_type?.charAt(0)?.toUpperCase() +
                      data?.request_type?.slice(1)}
                </span>
                {tab !== 1 &&
                  tab !== 2 &&
                  tab !== 3 &&
                  (data?.request_type == "update" ? (
                    <span
                      className="text-sm block text-blue-500 cursor-pointer text-center"
                      onClick={() => handleChangesOpen(data)}
                    >
                      View
                    </span>
                  ) : null)}
              </TableCell>
            )}

            {tab === 2 && (
              <TableCell className="text-sm text-center">
                {data.block_remark ? (
                  <span
                    className="text-sm text-blue-500 cursor-pointer text-center"
                    onClick={() => handleOpen(data.block_remark)}
                  >
                    View
                  </span>
                ) : null}

                {/* If no remarks are available */}
                {!data.block_remark && (
                  <span
                    className="text-sm"
                    style={{ display: "block", textAlign: "center" }}
                  >
                    {" "}
                    -{" "}
                  </span>
                )}
              </TableCell>
            )}
            {tab === 3 && (
              <TableCell className="text-sm cursor-pointer text-blue-500 text-center">
                {data.cancel_add_remarks ? (
                  <span onClick={() => handleOpen(data.cancel_add_remarks)}>
                    View
                  </span>
                ) : null}

                {data.cancel_update_remarks ? (
                  <span onClick={() => handleOpen(data.cancel_update_remarks)}>
                    View
                  </span>
                ) : null}

                {data.cancel_delete_remarks ? (
                  <span onClick={() => handleOpen(data.cancel_delete_remarks)}>
                    View
                  </span>
                ) : null}

                {/* If no remarks are available */}
                {!data.cancel_add_remarks &&
                  !data.cancel_update_remarks &&
                  !data.cancel_delete_remarks && (
                    <span className="block"> - </span>
                  )}
              </TableCell>
            )}
            {tab !== 0 && (
              <TableCell className="text-center text-sm">
                {data["driver_rating"] || "Not Updated"}
              </TableCell>
            )}

            <TableCell>
              <div className="flex justify-center text-right">
                <div className="p-2 cursor-pointer text-gray-400 hover:text-green-600">
                  <button
                    onClick={() => handleView(data.id, "Driver Details")}
                    className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                  >
                    <Tooltip
                      id={data.id}
                      Icon={FiEye}
                      title="ViewOrder"
                      bgColor="#34D399"
                    />
                  </button>
                </div>
                {tab !== 2 && (
                  <EditDeleteButton
                    title={data.Driver}
                    id={data.id}
                    tab={tab}
                    page="driver"
                    handleUpdate={handleUpdate}
                    handleModalOpen={handleModalOpen}
                    hideDelete={hideDelete}
                    hideEdit={hideEdit}
                  />
                )}
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            maxWidth: "90%",
            boxShadow: 24,
            maxHeight: "60vh",
            borderRadius: 2,
            padding: "20px",
          }}
          className="bg-white dark:bg-gray-700 dark:text-white"
        >
          {/* Close Icon */}
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <MdClose size={24} />
          </IconButton>

          <Typography variant="body1" sx={{ mt: 4 }}>
            {selectedRemark}
          </Typography>
        </Box>
      </Modal>

      {/* Changes View Modal  */}
      <Modal open={changesOpen} onClose={handleChangesClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            maxWidth: "90%",
            boxShadow: 24,
            maxHeight: "60vh",
            overflowY: "auto",
            borderRadius: 2,
            padding: "20px",
          }}
          className="bg-white dark:bg-gray-700 dark:text-white"
        >
          <IconButton
            onClick={handleChangesClose}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <MdClose size={24} />
          </IconButton>

          <Typography sx={{ mb: 2, fontWeight: 600 }}>
            Changes Made Details
          </Typography>

          {changesArrayData?.length > 0 ? (
            changesArrayData.map((item, index) => (
              <Box
                key={index}
                sx={{
                  mb: 2,
                  p: 2,
                  border: "1px solid #e5e7eb",
                  borderRadius: 2,
                }}
              >
                <Typography fontWeight={600} sx={{ mb: 1 }}>
                  {item.field}
                </Typography>

                <Typography
                  variant="body2"
                  style={{ textWrap: "wrap" }}
                  sx={{ color: "#dc2626", mb: 0.5 }}
                >
                  <strong>Old:</strong> {item.oldValue || "-"}
                </Typography>

                <Typography
                  variant="body2"
                  style={{ textWrap: "wrap" }}
                  sx={{ color: "#16a34a" }}
                >
                  <strong>New:</strong> {item.newValue || "-"}
                </Typography>
              </Box>
            ))
          ) : (
            <Typography variant="body2">No changes found.</Typography>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default DriverTable;
